const colors = {
  brand: '#414141',
  footer: {
    bg: '#333333'
  },
  headings: '#000000',
  input: {
    bg: '#FFFFFF',
    border: '#CCCCCC',
    color: '#666666'
  },
  sidebar: {
    bg: '#464646'
  },
  text: {
    light: '#999999',
    normal: '#666666'
  },
  vortex: {
    brand: '#642566',
    bg1: '#642566',
    bg2: '#813384'
  }
};

export default colors;



// WEBPACK FOOTER //
// ./src/config/colors.js